import * as types from "../types";

export const submitBidRequest = ({reqBid}) => ({
    type: types.SUBMIT_BID_REQUEST,
    payload:{
        reqBid
    }
})

export const submitBidSuccess = ({resBidSubmit}) => ({
    type: types.SUBMIT_BID_SUCCESS,
    payload:{
        resBidSubmit   
    }
})

export const submitBidFailure = ({error}) => ({
    type: types.SUBMIT_BID_FAILURE,
    payload: {
        error: error
    }
});

export const submitBidReset = () => ({
    type: types.SUBMIT_BID_RESET,
});
